// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nsfw-blur[data-v-7dbf3b36]{-webkit-backdrop-filter:blur(60px);backdrop-filter:blur(60px);position:absolute;top:0;height:100%;width:100%;color:#fff;text-transform:capitalize}.nsfw-blur .heading-nsfw[data-v-7dbf3b36]{font-weight:700}.nsfw-blur .nsfw-desc[data-v-7dbf3b36]{max-width:18.75rem;text-align:center}.nsfw-blur .nsfw-content[data-v-7dbf3b36]{cursor:pointer;bottom:3.125rem;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
